import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "flex flex-col items-center"
};
const _hoisted_2 = {
  class: "flex items-center w-full"
};
const _hoisted_3 = {
  key: 0,
  class: "w-4"
};
const _hoisted_4 = {
  class: "grow mr-2"
};
const _hoisted_5 = {
  class: "w-16 mr-2"
};
const _hoisted_6 = {
  key: 0,
  class: "rounded p-1 pr-2.5 ml-5 w-full"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "grow mr-2"
};
const _hoisted_9 = {
  class: "w-16 mr-2"
};
const _hoisted_10 = {
  key: 1,
  class: "flex items-center w-full mt-1"
};
const _hoisted_11 = {
  key: 0,
  class: "w-4"
};
const _hoisted_12 = {
  class: "grow mr-2"
};
const _hoisted_13 = {
  class: "w-16 mr-2"
};
import PlayerComponent from "@/modules/team/components/Player.vue";
import Icon from "@/modules/vue/components/Icon.vue";
import Progress from "@/modules/vue/components/Progress.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'SubstitutionPlayerRow',
  props: {
    match: null,
    team: null,
    player: null,
    selectedPlayerId: null,
    suspended: {
      type: Boolean
    },
    substitutedPlayerIds: null
  },
  emits: ['update:selectedPlayerId'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const showBranchPlayers = ref(false);
    const selectedPlayer = computed(() => benchPlayers.value.find(p => p.id === props.selectedPlayerId));
    const benchPlayers = computed(() => collect(props.team.players).where('lineup', null).filter(p => !p.suspensions.find(s => s.competitionId === props.match.matchday.division.competitionId)).filter(p => !props.substitutedPlayerIds.includes(p.id)).sortBy('order').toArray());
    const onSelectPlayer = playerId => {
      showBranchPlayers.value = false;
      emit('update:selectedPlayerId', playerId);
    };
    const unset = () => {
      emit('update:selectedPlayerId', null);
    };
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_unref(selectedPlayer) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(Icon, {
        icon: _ctx.IconEnum.ArrowLeft,
        size: ".75rem",
        class: "mr-1 text-red-600"
      }, null, 8, ["icon"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createVNode(PlayerComponent, {
        player: __props.player,
        "hide-age": "",
        "hide-energy": "",
        "no-link": ""
      }, null, 8, ["player"])]), _createElementVNode("div", _hoisted_5, [_createVNode(Progress, {
        value: __props.player.energy
      }, null, 8, ["value"])]), !__props.suspended ? (_openBlock(), _createBlock(_component_NButton, {
        key: 1,
        secondary: "",
        size: "small",
        type: "info",
        onClick: _cache[0] || (_cache[0] = $event => showBranchPlayers.value = !showBranchPlayers.value)
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.Add20Regular,
          size: ".75rem"
        }, null, 8, ["icon"])]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_NButton, {
        key: 2,
        secondary: "",
        size: "small",
        type: "error"
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.Ban,
          size: ".75rem"
        }, null, 8, ["icon"])]),
        _: 1
      }))]), showBranchPlayers.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(benchPlayers), player => {
        return _openBlock(), _createElementBlock("div", {
          key: player.id,
          class: "leading-none flex items-center cursor-pointer",
          onClick: () => onSelectPlayer(player.id)
        }, [_createElementVNode("div", _hoisted_8, [_createVNode(PlayerComponent, {
          player: player,
          "hide-age": "",
          "no-link": "",
          "hide-energy": ""
        }, null, 8, ["player"])]), _createElementVNode("div", _hoisted_9, [_createVNode(Progress, {
          value: player.energy
        }, null, 8, ["value"])]), _createElementVNode("div", null, [_createVNode(_component_NButton, {
          secondary: "",
          size: "small",
          type: "success"
        }, {
          default: _withCtx(() => [_createVNode(Icon, {
            icon: _ctx.IconEnum.CheckRound,
            size: ".75rem"
          }, null, 8, ["icon"])]),
          _: 1
        })])], 8, _hoisted_7);
      }), 128))])) : _createCommentVNode("", true), _unref(selectedPlayer) ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_unref(selectedPlayer) ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(Icon, {
        icon: _ctx.IconEnum.ArrowRight,
        size: ".75rem",
        class: "mr-1 text-green-600"
      }, null, 8, ["icon"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_createVNode(PlayerComponent, {
        player: _unref(selectedPlayer),
        "hide-age": "",
        "hide-energy": "",
        "no-link": ""
      }, null, 8, ["player"])]), _createElementVNode("div", _hoisted_13, [_createVNode(Progress, {
        value: _unref(selectedPlayer).energy
      }, null, 8, ["value"])]), _createVNode(_component_NButton, {
        secondary: "",
        size: "small",
        type: "error",
        class: "font-mono",
        onClick: unset
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.Subtract20Regular,
          size: ".75rem"
        }, null, 8, ["icon"])]),
        _: 1
      })])) : _createCommentVNode("", true)]);
    };
  }
});